const initialState = {
    dashboardDataList: [],
    isFetchingDashboardData: false,
};

const AccountsDashboardReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_DASHBOARD_DATA":
            return { ...state, isFetchingDashboardData: true };
        case "SUCCESS_DASHBOARD_DATA":
            return { ...state, dashboardDataList: action.payload, isFetchingDashboardData: false };
        case "ERROR_DASHBOARD_DATA":
            return { ...state, isFetchingDashboardData: false };


        default:
            return state;
    }
};

export default AccountsDashboardReducer;